import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Grid, IconButton, Typography } from "@mui/material";
import utilFunctions from "../../../utilities/utilFunctions";

// One row in the serving size list - name on the left, its measurement on the right, and a trash
// icon. Clicking the row itself opens the edit modal.
const ServingSizeCard = ({ servingSize, onEdit, onDelete }) => {
  const handleDeleteClick = (event) => {
    // the row is clickable for edit, so stop the delete icon from opening the edit modal too
    event.stopPropagation();
    onDelete(servingSize);
  };

  return (
    <Card
      onClick={() => onEdit(servingSize)}
      sx={{
        marginBottom: 2,
        borderRadius: 2,
        cursor: "pointer",
        border: (theme) => `1px solid ${theme.palette.terrain[300]}`,
        boxShadow: "none",
      }}
    >
      <CardContent
        sx={{
          "&:last-child": { paddingBottom: 4 },
        }}
      >
        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "nowrap",
          }}
        >
          <Grid item sx={{ minWidth: 0 }}>
            <Typography variant="h5" noWrap>
              {servingSize.name}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            {/* terrain["02"] flips with the mode - the numbered terrain scale inverts, so
                terrain[500] reads as near-invisible dark grey in dark mode */}
            <Typography
              variant="body1"
              sx={{ color: (theme) => theme.palette.terrain["02"] }}
            >
              {utilFunctions.extractServingSizeDisplay(servingSize)}
            </Typography>
            <IconButton
              onClick={handleDeleteClick}
              aria-label={`Delete ${servingSize.name}`}
              sx={{
                border: "2px solid",
                borderColor: (theme) => theme.palette.primary[800],
                height: "40px",
                width: "40px",
              }}
            >
              <DeleteOutlinedIcon
                sx={{ color: (theme) => theme.palette.primary[800] }}
              />
            </IconButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ServingSizeCard;
